module.exports = {
  "/:pageTypeSlug/:contentId": {
    "name": "index-redirect"
  },
  "/:pageTypeSlug/:contentId/performance": {
    "success": {
      "empty state": [
        "PERFORMANCE_TAB_EMPTY_LOADED"
      ],
      "tables loaded": [
        "PERFORMANCE_TAB_LOADED"
      ]
    }
  },
  "/:pageTypeSlug/:contentId/optimization": {
    "name": "optimization-redirect"
  },
  "/:pageTypeSlug/:contentId/optimization/:optimizationTab": {
    "success": {
      "keyword": [
        "OPTIMIZATION_TAB_LOADED",
        "OPTIMIZATION_KEYWORD_LOADED"
      ],
      "internal links": [
        "OPTIMIZATION_TAB_LOADED",
        "OPTIMIZATION_INTERNAL_LINKS_LOADED"
      ],
      "panel": [
        "OPTIMIZATION_TAB_LOADED",
        "OPTIMIZATION_PANEL_LOADED"
      ]
    }
  },
  "/:pageTypeSlug/:contentId/testResults": {
    "name": "test-results",
    "success": {
      "Personalization expirement with data": [
        "PERSONALIZATION_LOADED"
      ],
      "Personalization experiment running no data": [
        "PERSONALIZATION_NO_DATA_LOADED"
      ],
      "Personalization experiment not started": [
        "PERSONALIZATION_NOT_STARTED_LOADED"
      ],
      "Personalization experiment ended with no data or no experiment": [
        "PERSONALIZATION_RESULTS_NO_DATA_LOADED"
      ],
      "Variations loaded": [
        "VARIATIONS_LOADED"
      ]
    }
  },
  "/:pageTypeSlug/:pageId/smartContent": {
    "name": "smart-content",
    "success": {
      "smart content loaded no data": [
        "SMART_CONTENT_LOADED_NO_DATA"
      ],
      "smart content loaded": [
        "SMART_CONTENT_LOADED"
      ]
    }
  },
  "/external-page/optimization/:somePath": {
    "name": "external-page-routes",
    "success": {
      "keyword": [
        "OPTIMIZATION_KEYWORD_LOADED"
      ],
      "inbound links": [
        "OPTIMIZATION_TAB_LOADED"
      ],
      "internal links": [
        "OPTIMIZATION_INTERNAL_LINKS_LOADED"
      ],
      "panel": [
        "OPTIMIZATION_TAB_LOADED",
        "OPTIMIZATION_PANEL_LOADED"
      ]
    }
  }
};